module.exports = __webpack_public_path__ + "862ca2df41d3d7b3cd4684655fde481c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GB.svg
// module id = +CMp
// module chunks = 0